import axios from "axios";
import { Api_Caller } from "../../../utils/Api";


const BASE_URL = process.env.REACT_APP_API_ALL;

const getHeaders = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

// ======================
// Attendance Details
// ======================

export const getAttendanceDetailsApi = (employeeId, date, token) => {
  return axios.get(
    `${BASE_URL}/${Api_Caller.attendanceDetails}/${employeeId}`,
    {
      params: {
        date,
      },
      ...getHeaders(token),
    }
  );
};

// ======================
// Route
// ======================

export const getRouteApi = (sessionId, token) => {
  return axios.get(
    `${BASE_URL}/${Api_Caller.tracking}/${sessionId}/route`,
    getHeaders(token)
  );
};

// ======================
// Visits
// ======================

export const getVisitsApi = (sessionId, token) => {
  return axios.get(
    `${BASE_URL}/${Api_Caller.getVisitsBySession}/${sessionId}`,
    getHeaders(token)
  );
};

// ======================
// Selfies
// ======================

export const getSelfiesApi = (sessionId, token) => {
  return axios.get(
    `${BASE_URL}/${Api_Caller.getSelfies}/${sessionId}/selfies`,
    getHeaders(token)
  );
};